import { useMe } from '@core/hooks/use-me.js';
import { useReleaseToggle } from '@core/hooks/use-release-toggle.js';
import { createFileRoute, Navigate } from '@tanstack/react-router';

import { MemoryViewerPage } from '../features/projects/detail/memory-viewer/memory-viewer-page.js';

function MemoryViewerRoute() {
  const { teamId, projectId } = Route.useParams();
  const me = useMe();
  // The viewer reads memory the agent-sessions surface produces; it rides the
  // same release toggle so the whole v2 surface goes light/dark together.
  const enabled = useReleaseToggle('agent_sessions');
  // Fail closed only once /me resolved — the toggle reads false while loading.
  if (me.isLoading) return null;
  if (!enabled) {
    // A dark feature's deep link behaves like an unknown URL (the catch-all
    // route's redirect), matching the backend's 404.
    return <Navigate to="/login" replace />;
  }
  return <MemoryViewerPage teamId={teamId} projectId={projectId} />;
}

export const Route = createFileRoute('/_authed/teams/$teamId/projects/$projectId/memory')(
  {
    component: MemoryViewerRoute,
  },
);
